import { useEffect, useState } from "react";
import { loadGoogleMaps } from "@/lib/google-maps";
import { useConfig } from "./useConfig";

interface GoogleMapsState {
  google: typeof google | null;
  unavailable: boolean;
}

/** Loads the Google Maps + Places script as soon as the runtime config is
 *  available, then returns the global `google` object. Components consuming
 *  this can fall back to manual entry when `unavailable` is true. */
export function useGoogleMaps(): GoogleMapsState {
  const { data: config } = useConfig();
  const [state, setState] = useState<GoogleMapsState>({ google: null, unavailable: false });

  useEffect(() => {
    let cancelled = false;
    if (!config?.mapsApiKey) return;
    loadGoogleMaps(config.mapsApiKey)
      .then((g) => {
        if (cancelled) return;
        setState({ google: g, unavailable: false });
      })
      .catch((err) => {
        console.warn("[google-maps] load failed:", err);
        if (cancelled) return;
        setState({ google: null, unavailable: true });
      });
    return () => {
      cancelled = true;
    };
  }, [config?.mapsApiKey]);

  return state;
}
